import { Divider } from '@mui/material'
import CreditCardPanel from 'components/Sell/payment/CreditCardPanel'
import usePaymentContext from 'components/Sell/payment/hook/usePaymentContext'
import PaymentDialogMobileContent from '../PaymentDialogMobileContent'
import PaymentMobileDetail from '../PaymentMobileDetail'
import FinishPaymentButton from '../FinishPaymentButton'
import { usePaymentCalculation } from 'components/Sell/payment/hook/usePaymentCalculation'

function CreditCardMobilePayment({
    onBack,
    onSubmitPayment,
}: {
    onBack: () => void
    onSubmitPayment: () => void
}) {
    const {
        tenderedAmount,
        selectedPaymentType,
        expectAmount,
        payment,
        isReadyToProceedPayment,
    } = usePaymentContext()

    const { isMoneyCollect } = usePaymentCalculation({
        selectedPaymentType,
        expectAmount,
        payment,
    })

    return (
        <PaymentDialogMobileContent
            onBack={onBack}
            topSection={
                <>
                    <CreditCardPanel
                        tenderedAmount={tenderedAmount.toNumber()}
                    />
                    <Divider sx={{ marginY: 2 }} />
                </>
            }
            bottomSection={
                <>
                    <PaymentMobileDetail />
                </>
            }
            finishButton={
                <FinishPaymentButton
                    onConfirm={onSubmitPayment}
                    onCancel={onBack}
                    isMoneyCollect={isMoneyCollect}
                    isReadyToProceedPayment={isReadyToProceedPayment}
                />
            }
        />
    )
}
export default CreditCardMobilePayment
